export default "__VITE_ASSET__BbSAF$HF__"